import {MetaReducer, provideState} from "@ngrx/store";

import { sharedReducer, sharedStoreFeatureKey } from "./shared/store/shared.reducer";
import { searchReducer, searchStoreFeatureKey } from "./search/store/search.reducer";
import { assetReducer, assetStoreFeatureKey } from "./asset/store/asset.reducer";
import { fundReducer, fundStoreFeatureKey } from "./fund/store/fund.reducer";
import { dealReducer, dealStoreFeatureKey } from "./deal/store/deal.reducer";
import { importReducer, importStoreFeatureKey } from "./import/store/import.reducer";
import { importHydrationMetaReducer } from "./import/store/import-hydration.reducer";
import { patternGroupReducer} from "./shared/store/pattern-group/pattern-group.reducer";
import { patternGroupFeatureKey } from "./shared/store/pattern-group/pattern-group.state";
import { userSettingReducer, userSettingStoreFeatureKey } from "./shared/user-setting/store/user-setting.reducer";
import { aiChatReducer } from "./shared/store/ai-chat/ai-chat.reducer";
import { aiChatFeatureKey } from "./shared/store/ai-chat/ai-chat.state";
import { fundAiSetupReducer } from "./fund-ai-setup/store/fund-ai-setup.reducer";
import { FUND_AI_SETUP_FEATURE_KEY } from "./fund-ai-setup/store/fund-ai-setup.selectors";
import { algorithmicDmvReducer } from "./algorithmic-dmv/store/algorithmic-dmv.reducer";
import { ALGORITHMIC_DMV_FEATURE_KEY } from "./algorithmic-dmv/store/algorithmic-dmv.selectors";
import { notificationReducer } from "./notification/store/notification.reducer";
import { notificationStoreFeatureKey } from "./notification/store/notification.state";
import { favoriteReducer } from "./favorites/store/favorite.reducer";
import { favoriteStoreFeatureKey } from "./favorites/store/favorite.state";
import { commentReducer } from "./comment/store/comment.reducer";
import { commentStoreFeatureKey } from "./comment/store/comment.state";

const importMetaReducers: MetaReducer[] = [importHydrationMetaReducer];

export const APP_STATE_PROVIDERS = [
    provideState(sharedStoreFeatureKey, sharedReducer),
    provideState(searchStoreFeatureKey, searchReducer),
    provideState(assetStoreFeatureKey, assetReducer),
    provideState(fundStoreFeatureKey, fundReducer),
    provideState(dealStoreFeatureKey, dealReducer),
    provideState(importStoreFeatureKey, importReducer, { metaReducers: importMetaReducers }),
    provideState(patternGroupFeatureKey, patternGroupReducer),
    provideState(userSettingStoreFeatureKey, userSettingReducer),
    provideState(aiChatFeatureKey, aiChatReducer),
    provideState(FUND_AI_SETUP_FEATURE_KEY, fundAiSetupReducer),
    provideState(ALGORITHMIC_DMV_FEATURE_KEY, algorithmicDmvReducer),
    provideState(notificationStoreFeatureKey, notificationReducer),
    provideState(favoriteStoreFeatureKey, favoriteReducer),
    provideState(commentStoreFeatureKey, commentReducer),
];
